/**
 * Helpers de réduction d'URL pour alléger le cookie `taleez_tracking`.
 *
 * Les URLs complètes (query string + hash) dupliquent les UTM et click-ids
 * déjà rangés dans leurs propres champs. On ne stocke que le strict nécessaire :
 * `origin + pathname` pour les landing pages, `hostname` pour le referrer.
 */

/**
 * Réduit une URL de landing page à `origin + pathname`
 * (query string et hash retirés).
 *
 * - Chaîne vide ou URL non parsable → ''.
 * - URL racine (sans chemin) → `origin + '/'`.
 */
export function slimUrl(url: string): string {
  if (!url) return '';
  try {
    const parsed = new URL(url);
    return parsed.origin + parsed.pathname;
  } catch {
    return '';
  }
}

/**
 * Réduit une URL de referrer à son `hostname` seul.
 *
 * - Chaîne vide ou URL non parsable → ''.
 */
export function slimReferrer(url: string): string {
  if (!url) return '';
  try {
    return new URL(url).hostname;
  } catch {
    return '';
  }
}
